import { BookLocation } from '../../../dorian-shared/types/bookLocation/bookLocation';
import { Branch } from '../../../dorian-shared/types/branch/Branch';
import { MemoryDTO } from '../../../components/pages/Book/MemoryBank/memoryBankTypes';
import { EpisodeTextImportNode } from '../models/EpisodeTextImportNode';

export enum EpisodeTextColumnKey {
  NodeOrSpeaker = 0,
  Text = 1,
  Description = 2,
}

export enum EpisodeTextEntityType {
  Node = 'node',
  EmptyStep = 'emptyStep',
  Dialogue = 'dialogue',
  Thinking = 'thinking',
  thoughtful = 'thoughtful',
  Reaction = 'reaction',
  Narration = 'narration',
  Choice = 'choice',
  Answer = 'answer',
  Skip = 'skip',
  GotoFromNode = 'goto',
  Chat = 'chat',
  Remember = 'remember',
  Random = 'random',
  Check = 'check',
  CheckConditionList = 'checkConditionList',
  CheckCondition = 'checkCondition',
  Ending = 'ending',
  Video = 'video',
  Achieve = 'achieve',
}

export type EpisodeTextImportNodeValidationConfig = {
  nodesInImport: EpisodeTextImportNode[],
  maxLengthName?: number;
  maxLengthText?: number;
  nodeNamesInEpisode?: string[];
  bookLocations?: BookLocation[];
}

export type EpisodeTextImportStepValidationConfig = {
  bookLocations?: BookLocation[];
  nodesInImport: EpisodeTextImportNode[],
  maxLengthName?: number;
  maxLengthText?: number;
  nodesInEpisode?: Branch[];
  characterNamesInBook?: string[];
  memoriesInBook?: MemoryDTO[];
  /** Achievement name (lowercase) → reward ID mapping for PlayerHas validation */
  rewardIds?: Map<string, number>;
}
